import React, { useEffect, useState } from "react";
import { Grid, Button, Alert, Form } from "tabler-react";
import { ContentTextProps, blackListProps } from "../../types";
import ServerSidePagination from "../../components/pagination/serverSidePagination";
import TableCard from "../../components/tableCard";
import TableModal from "./tableModal";

import "./style.css";
import ReactModal from "react-modal";
import { alertCustomStyles } from "../../helpers";
import moment from "moment";

const AutomationUnits = ({
  data,
  loading,
  deleteUnit,
  updateUnit,
  createAutomationUnit,
  onPageNumberChange,
}: any): JSX.Element => {
  const [automationUnitList, setAutomationUnitList] = useState<
    Array<blackListProps>
  >([]);
  const [dataLoading, setDataLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [mutationCompleted, setMutationCompleted] = useState(false);
  const [EditType, setEditType] = useState<any>();
  const [total, setTotal] = useState(0);
  const [editField, setEditField] = useState<any>(null);

  const handleModal = () => {
    if (showModal) {
      setEditField(null);
      setErrorMessage("");
    }
    setShowModal(!showModal);
  };

  const handleSave = async ({ ...rest }) => {
    const { name } = rest;
    if (EditType) {
    } else {
      const res = await createAutomationUnit({
        variables: { settings: { name: name } },
      });
      if (
        res.data.HexomaticAdminOps &&
        !res.data.HexomaticAdminOps.createAutomationUnit
      ) {
        handleModal();
        return;
      }
      const { error_code } = res.data.HexomaticAdminOps.createAutomationUnit;
      if (error_code) {
        setErrorMessage(error_code);
        return;
      }
    }
    return true;
  };

  const onDelete = async (id: number) => {
    let deleteConfirm = confirm(
      `Are you sure you want to delete automation type with ID: ${id}`
    );
    if (!deleteConfirm) return;
    const res = await deleteUnit({
      variables: { settings: { unit_id: id } },
    });
    if (
      res.data.HexomaticAdminOps &&
      !res.data.HexomaticAdminOps.deleteAutomationUnit
    ) {
      setAutomationUnitList(
        automationUnitList.filter((item) => item.id !== id)
      );
      return;
    }
    const { error_code } = res.data.HexomaticAdminOps.deleteAutomationUnit;
    if (error_code) {
      setErrorMessage(error_code);
      return;
    }
  };

  const onUpdate = async ({ unit_id, name }) => {
    const res = await updateUnit({
      variables: { settings: { unit_id, name } },
    });
    handleModal();
    if (
      res.data.HexomaticAdminOps &&
      !res.data.HexomaticAdminOps.deleteAutomationUnit
    ) {
      const newAutomationTypeList = automationUnitList.map((item) => {
        if (item.id === unit_id) {
          return { ...item, name: name };
        }
        return item;
      });
      setAutomationUnitList(newAutomationTypeList);
      return;
    }
    const { error_code } = res.data.HexomaticAdminOps.updateAutomationUnit;
    if (error_code) {
      setErrorMessage(error_code);
      return;
    }
  };

  const tableData = {
    tData:
      automationUnitList &&
      automationUnitList.map((item: ContentTextProps) => ({
        id: item.id,
        name: item.name,
        created: moment(item.createdAt).utc().format("DD-MM-YYYY hh:mm:ss a"),
        updated: item.updated_at
          ? moment(+item.updated_at)
              .utc()
              .format("DD-MM-YYYY hh:mm:ss a")
          : "not updated",
        Action: (
          <Button.List>
            <Button
              color="primary"
              icon="edit"
              onClick={() => {
                setEditField(item);
                setShowModal(true);
              }}
            />
            <Button
              color="danger"
              icon="trash"
              onClick={() => onDelete(item.id)}
            />
          </Button.List>
        ),
      })),
  };

  useEffect(() => {
    if (
      data &&
      data.HexomaticAdmin &&
      data.HexomaticAdmin.getAutomationUnits.units
    ) {
      setDataLoading(loading);
      setAutomationUnitList(data.HexomaticAdmin.getAutomationUnits.units);
      // setTotal(data.EmailBlackList.adminGetMany.total)
    }
  }, [data]);

  return (
    <Grid.Row cards deck>
      <TableModal
        handleModal={handleModal}
        showModal={showModal}
        onSave={handleSave}
        onUpdate={onUpdate}
        editField={editField}
        errorMessage={errorMessage}
      />
      <ReactModal isOpen={!!errorMessage} style={alertCustomStyles}>
        {errorMessage ? <Alert type="danger">{errorMessage}</Alert> : null}
        <Button
          className=""
          onClick={() => setErrorMessage("")}
          color="primary"
        >
          OK
        </Button>
      </ReactModal>
      <div className="col-12 col-md-1 col-xs-6">
        <Button className="" onClick={() => setShowModal(true)} color="primary">
          Create
        </Button>
        <br />
      </div>
      <Grid.Col md={9}></Grid.Col>
      <div className="col-12 col-md-2 col-xs-6">
        <Alert type="info">
          Result Count - {total || automationUnitList.length}
        </Alert>
      </div>
      <div className="black-list-table-pagination">
        <ServerSidePagination
          data={automationUnitList}
          total={total}
          onPageNum={onPageNumberChange}
        >
          <TableCard
            loading={false}
            data={automationUnitList}
            tableData={tableData}
          />
        </ServerSidePagination>
      </div>

      {automationUnitList.length ? (
        <div className="col-12 col-md-2 col-xs-12 offset-md-10">
          <Alert type="info">
            Result Count - {total || automationUnitList.length}
          </Alert>
        </div>
      ) : null}
    </Grid.Row>
  );
};

export default AutomationUnits;
